module.exports = __webpack_public_path__ + "static/media/low_on_waist.c9c590ba.svg";